export default "__VITE_ASSET__4a0b0af1__"